import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import { FormProvider as FormProvider$1 } from 'react-hook-form';
import { useReactHookForm } from '../Form/useReactHookForm.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "defaultValues", "disableAll", "inlineAll", "onChange", "onSubmit", "onValidationError", "reValidateMode", "validateMode"];
var FormProvider = FormProvider$1;
function Component(props, ref) {
  var children = props.children,
    defaultValues = props.defaultValues,
    disableAll = props.disableAll,
    inlineAll = props.inlineAll,
    onChange = props.onChange,
    onSubmit = props.onSubmit,
    onValidationError = props.onValidationError,
    _props$reValidateMode = props.reValidateMode,
    reValidateMode = _props$reValidateMode === void 0 ? "onBlur" : _props$reValidateMode,
    _props$validateMode = props.validateMode,
    validateMode = _props$validateMode === void 0 ? "onSubmit" : _props$validateMode,
    rest = _objectWithoutProperties(props, _excluded);
  var prevErrors = React.useRef({});
  var methods = useReactHookForm({
    defaultValues: defaultValues,
    mode: validateMode,
    reValidateMode: reValidateMode,
    onChange: onChange
  }, ref);
  React.useEffect(function () {
    var errors = JSON.parse(JSON.stringify(methods.formState.errors));
    if (onValidationError && !isEqual(prevErrors.current, errors)) {
      prevErrors.current = errors;
      onValidationError(errors);
    }
  }, [methods.formState]);
  return /*#__PURE__*/jsx(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
    disableAll: disableAll,
    inlineAll: inlineAll,
    children: /*#__PURE__*/jsx("form", _objectSpread(_objectSpread({}, rest), {}, {
      onSubmit: onSubmit && methods.handleSubmit(onSubmit),
      children: children
    }))
  }));
}
Component.displayName = "FormContainer";
var FormContainer = /*#__PURE__*/React.forwardRef(Component);

export { FormContainer };
